import {
  MoneyAdjustment as CoreMoneyAdjustment,
  type MoneyAdjustmentProps as CoreMoneyAdjustmentProps,
} from '@zealth/core/adjustments'

import { BaseAdjustment } from './BaseAdjustment'

/**
 * Web-bound `MoneyAdjustment`: same as core's, but with the platform's
 * `BaseAdjustment` pre-injected so consumers don't have to thread it
 * through every call site.
 */
export type MoneyAdjustmentProps = Omit<
  CoreMoneyAdjustmentProps,
  'BaseAdjustment'
>

export const MoneyAdjustment = (props: MoneyAdjustmentProps) => (
  <CoreMoneyAdjustment BaseAdjustment={BaseAdjustment} {...props} />
)
